export const mainActionTypes = {
	SET_LOADER_ACTIVE: "SET_LOADER_ACTIVE",
	SET_LOADER_INACTIVE: "SET_LOADER_INACTIVE"
};
